/* eslint-disable no-unused-vars */
var utils_vars = {
	root: document.documentElement,
	head: document.head,
	body: document.body,
	headerDown: false,
	originalState: true,
	breakpoint: {
		xs: 0,
		sm: 576,
		md: 768,
		lg: 992,
		xl: 1200,
		xxl: 1400,
	},
	observerReady : "IntersectionObserver" in window,
    observerLoaded : false,
    observerStartLoaded : false,
	lazyImageObserver: false,
	srcsetReady: 'sizes' in document.createElement('img'),
	notStarted: true,
	webmReady: false,
	menuOpen: false,
	closeMenu: false,
	isMobile: false,
	overlay: document.getElementById('overlay'),
	sliderLoaded: false,
	
	// funzione di caricamento ajax
	ajaxLoad(url, method, contentType, type, params, callback) {
		var oReq = new XMLHttpRequest();
		oReq.onload = function (e) {
			var response = e.target.response;
			if (callback) {
				callback(response);
			}
		};
		oReq.open(method, url, true);
		if (type) {
			oReq.responseType = type;
		}
		if (contentType) {
			oReq.setRequestHeader('Content-type', contentType);
		}
		if (params) {
			oReq.send(params);
		} else {
			oReq.send();
		}
	},

	// DOM ready
	domReady: (callback) => {
		document.readyState === "interactive" || document.readyState === "complete" ? callback() : document.addEventListener("DOMContentLoaded", callback);
	},

	// loop helper
	forEach(array, callback, scope) {
		for (var i = 0; i < array.length; i++) {
			callback.call(scope, i, array[i]);
		}
	},

	loadScript(link, async, callback) {
		var script = document.createElement("script");
		script.src = link;
		if (async) {
			script.setAttribute('async', '');
		}
		if (callback) {
			script.addEventListener('load', callback);
		}
		document.body.appendChild(script);
	},

	setCookie(name, value, minutes) {
		var expires = "";
		if (minutes) {
			var date = new Date();
			date.setTime(date.getTime() + minutes * 60 * 1000);
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	},

	getCookie(cname) {
		let name = cname + "=";
		let ca = document.cookie.split(";");
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == " ") {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	},

}

export default utils_vars
